<template>
    <div class="main">
        <tabledata :allStore="allStore" ref="tabledata"></tabledata>
    </div>
</template>

<script>
import tabledata from './components/datascreening.vue';
export default {
    props: {
        allStore: {
            type: Array,
            default: () => []
        }
    },
    components: {
        tabledata
    },
    methods: {
        handleQuery() {
            this.$refs.tabledata && this.$refs.tabledata.onSubmit();
        }
    }
}
</script>

<style lang="scss" scoped>
.main {
    width: 95%;
    margin: 10px auto;
    font-size: 16px;
    color: #ffffff;
    box-shadow: 0 0 10px;
    border: 1px solid #5c01b8;
    border-radius: 30px;
    box-sizing: border-box;
}

#app .pageMain>div {
    width: 100%;
    padding: 0;
}
</style>